<template>

    <template v-if="($route.params.psPage === 'Listar')">
        <v-container fluid>
            <v-row class="mb-3">
                <v-col cols="12" md="4">
                    <v-select
                        v-model="selectedTurmaCodigo"
                        density="comfortable"
                        item-title="label"
                        item-value="codigo"
                        label="Turma"
                        prepend-inner-icon="mdi-account-group"
                        variant="outlined"
                        :items="turmas"
                        :loading="loadingTurmas"
                        @update:model-value="handleTurmaChange"
                    />
                </v-col>
            </v-row>
            <v-data-table v-model:sort-by="sortByData" class="table elevation-2" hover
            items-per-page-text="Itens por pagina" page-text="{0}-{1} de {2}"
            :headers="headersTests" :items="listTests" :loading="loadingTests">
                <template v-slot:no-data>
                    <v-alert class="my-4" :value="true">
                        <v-icon class="mt-n1 mr-2" color="warning" icon="mdi-alert" /> Desculpe, sem dados para exibir :(
                    </v-alert>
                </template>
                <template v-slot:item.datetime="{ item }">{{ formatDate(item.columns.datetime) }}</template>
                <template v-slot:item.id="{ item }">
                    <v-icon icon="mdi-numeric-10-box-multiple-outline" class="ma-2 pa-2" color="secondary" size="small" @click="seeGrades(item.columns.id)" />
                    <v-icon icon="mdi-chart-bar" class="ma-2 pa-2" color="primary" size="small" @click="seeReports(item.columns.id)" />
                    <v-icon
                        v-if="$store.state.userType !== 'coordenador' && !String(item.columns.get_status_display || '').toLowerCase().includes('conclu')"
                        icon="mdi-delete"
                        class="ma-2 pa-2"
                        color="error"
                        size="small"
                        @click="deleteTestAsk(item.columns.id)"
                    />
                    <v-icon v-else-if="$store.state.userType !== 'coordenador'" icon="mdi-delete" class="ma-2 pa-2" color="grey-lighten-3" size="small" />
                </template>
            </v-data-table>
        </v-container>

        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-toolbar class="bg-primary-darken-1" elevation="1">
                    <v-spacer />
                    <v-icon color="warning" icon="mdi-alert" size="x-large" />
                    <v-spacer />
                </v-toolbar>
                <v-card-title class="text-center">Voce tem certeza que deseja deletar esta<br />atividade avaliativa?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" variant="flat" @click="deleteTestConfirm(idTest)">Sim</v-btn>
                    <v-btn class="bg-primary" variant="flat" @click="closeDelete">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </template>

    <template v-else-if="($route.params.psPage === 'Notas')">
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-card class="mx-auto" prepend-icon="mdi-note">
                        <template v-slot:title>{{ provaNome }}</template>
                        <v-card-text>
                            <p><strong>Data:</strong> {{ datetime }}</p>
                            <p><strong>Status:</strong> {{ statusProva }}</p>
                            <p><strong>{{ pt }}</strong> {{ $store.state.userName }}</p>
                            <p v-if="optGabarito"><strong>Obs.:</strong> {{ optGabarito }}</p>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-card class="mx-auto" min-height="100">
                        <v-container class="text-center">
                            <v-row justify="center">
                                <v-col cols="12" md="3" sm="4">
                                    Nota Maxima:
                                    <v-btn active block class="disable-events" rounded="xl" size="x-large">{{ notaMaxima }}</v-btn>
                                </v-col>
                                <v-col cols="12" md="3" sm="4">
                                    Nota Individual:
                                    <v-btn block class="disable-events" rounded="xl" size="x-large">{{ notaIndividual }}</v-btn>
                                </v-col>
                                <v-col cols="12" md="3" sm="4">
                                    Nota em Equipe:
                                    <v-btn block class="disable-events" rounded="xl" size="x-large">{{ notaEquipe }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-card class="mx-auto" min-height="100">
                        <v-card-text>
                            <v-data-table v-model:sort-by="sortByName" class="table elevation-2" hover
                                items-per-page-text="Itens por pagina" page-text="{0}-{1} de {2}"
                                :headers="headersStudentsGrades"
                                :items="listStudentsGrades" :loading="loadingStudentsGrades" >
                                <template v-slot:no-data>
                                    <v-alert class="my-4" :value="true">
                                        <v-icon class="mt-n1 mr-2" color="warning" icon="mdi-alert" /> Desculpe, sem dados para exibir :(
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-card-text>
                        <v-card-actions class="ml-2">
                            <v-row>
                                <v-col cols="12" md="2" sm="3"><p><strong>AI:</strong> Atividade Individual</p></v-col>
                                <v-col cols="12" md="2" sm="3"><p><strong>AE:</strong> Atividade em Equipe</p></v-col>
                                <v-col cols="12" md="2" sm="3"><p><strong>Q:</strong> Questão</p></v-col>
                                <v-spacer />
                                <v-col class="mt-n3" cols="12" md="3" sm="3">
                                    <div style="align-items: center; display: flex;">
                                        <p>Exportar dados para:</p>
                                        <download-excel :data="listStudentsGrades" :fields="json_fields" :name="provaNome + '.xls'">
                                            <v-btn color="secondary" icon="mdi-microsoft-excel" variant="text" />
                                        </download-excel>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </template>

    <template v-else-if="($route.params.psPage === 'Estatisticas')">
        <v-container fluid>

            <!-- Cabeçalho da prova -->
            <v-row>
                <v-col>
                    <v-card class="mx-auto" prepend-icon="mdi-note">
                        <template v-slot:title>{{ provaNome }}</template>
                        <v-card-text>
                            <p><strong>Data:</strong> {{ datetime }}</p>
                            <p><strong>Status:</strong> {{ statusProva }}</p>
                            <p><strong>{{ pt }}</strong> {{ $store.state.userName }}</p>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <!-- Gráfico 1 + 2: Barras Empilhadas AI+AE  |  Histograma notas finais -->
            <v-row v-if="chartDataBarStacked.datasets.length" class="mt-2">
                <v-col cols="12" md="7">
                    <v-card elevation="2">
                        <v-toolbar color="primary" elevation="1">
                            <v-spacer />Notas por Aluno — AI + AE (empilhado)<v-spacer />
                        </v-toolbar>
                        <v-card-text style="height: 320px;">
                            <Bar :data="chartDataBarStacked" :options="charOptionsBarStacked" />
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="5">
                    <v-card elevation="2">
                        <v-toolbar color="secondary" elevation="1">
                            <v-spacer />Distribuição das Notas Finais<v-spacer />
                        </v-toolbar>
                        <v-card-text style="height: 320px;">
                            <Bar :data="chartDataHistogram" :options="charOptionsHistogram" />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row class="mt-2">
                <v-col cols="12" md="4">
                    <v-card elevation="2" height="100%">
                        <v-toolbar color="primary" elevation="1">
                            <v-spacer />Alunos da atividade<v-spacer />
                        </v-toolbar>
                        <v-card-text>
                            <v-alert v-if="!listDashboardStudents.length" class="my-4" :value="true">
                                <v-icon class="mt-n1 mr-2" color="warning" icon="mdi-alert" />
                                Nenhum aluno com nota calculada nesta atividade.
                            </v-alert>
                            <div v-else class="dashboard-student-scroll">
                                <v-chip-group
                                    v-model="selectedDashboardStudentId"
                                    direction="vertical"
                                    class="dashboard-student-chip-group"
                                >
                                    <v-chip
                                        v-for="student in listDashboardStudents"
                                        :key="student.usuario"
                                        :value="student.usuario"
                                        variant="tonal"
                                        class="dashboard-student-chip"
                                        :class="{ 'selected-chip': selectedDashboardStudentId === student.usuario }"
                                        @click="selectDashboardStudent(student)"
                                    >
                                        <div class="dashboard-student-chip-content">
                                            <strong>{{ student.nome_usuario }}</strong>
                                            <span>Final: {{ student.totalF }} | AI: {{ student.totalPI }} | AE: {{ student.totalPG }}</span>
                                        </div>
                                    </v-chip>
                                </v-chip-group>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="8" v-if="selectedStudentGauge">
                    <v-card elevation="2" height="100%">
                        <v-toolbar color="secondary" elevation="1">
                            <v-spacer />Dashboard do aluno selecionado<v-spacer />
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <div style="height: 200px; position: relative;">
                                        <Doughnut :data="selectedStudentGauge" :options="charOptionsGauge" />
                                    </div>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <div style="height: 200px; position: relative;">
                                        <Doughnut :data="selectedStudentGaugeAI" :options="charOptionsGauge" />
                                    </div>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <div style="height: 200px; position: relative;">
                                        <Doughnut :data="selectedStudentGaugeAE" :options="charOptionsGauge" />
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                    <div style="height: 260px;">
                                        <Bar :data="selectedStudentBarAI" :options="charOptionsBarPerQ" />
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div style="height: 260px;">
                                        <Bar :data="selectedStudentBarAE" :options="charOptionsBarPerQ" />
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <!-- Gráficos 3 e 4: Radar AI  |  Radar AE — separados -->
            <v-row v-if="chartDataRadarAI.datasets.length" class="mt-2">
                <v-col cols="12" md="6">
                    <v-card elevation="2">
                        <v-toolbar color="secondary" elevation="1">
                            <v-spacer />Acertos por Questão — Atividade Individual (%)<v-spacer />
                        </v-toolbar>
                        <v-card-text>
                            <Radar :data="chartDataRadarAI" :options="charOptionsRadar" />
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card elevation="2">
                        <v-toolbar elevation="1" style="background: #B88645; color: #fff;">
                            <v-spacer />Acertos por Questão — Atividade em Equipe (%)<v-spacer />
                        </v-toolbar>
                        <v-card-text>
                            <Radar :data="chartDataRadarAE" :options="charOptionsRadar" />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <!-- Gráficos existentes: pizza por questão -->
            <v-row class="mt-2">
                <v-col>
                    <v-card v-for="(card, index) in listTestReport" :key="index" class="mx-auto mb-4" min-height="200">
                        <v-toolbar color="primary-darken-1" elevation="2">
                            <v-spacer />Questão {{ index + 1 }} de {{ nQuestoes }}<v-spacer />
                        </v-toolbar>
                        <v-card-title v-html="sanitizeHtml(card.question)" class="mt-2 mx-auto text-wrap" />
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6" sm="6">
                                    <v-card>
                                        <v-toolbar color="primary" elevation="2">
                                            <v-spacer />Respostas da Atividade Individual<v-spacer />
                                        </v-toolbar>
                                        <v-card-text>
                                            <Pie :data="chartData[index]" :options="charOptions" />
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" md="6" sm="6">
                                    <v-card>
                                        <v-toolbar color="secondary" elevation="2">
                                            <v-spacer />Respostas da Atividade em Equipe<v-spacer />
                                        </v-toolbar>
                                        <v-card-text>
                                            <Pie :data="chartDataGrupo[index]" :options="charOptions" />
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

        </v-container>
    </template>

    <v-snackbar v-model="snackbar" :color="sbColor">
        {{ sbMessage }}
        <template v-slot:actions>
            <v-btn @click="snackbar = false">
                Fechar
            </v-btn>
        </template>
    </v-snackbar>

</template>

<style type="text/css">
.disable-events {
    pointer-events: none
}

.v-data-table.table .v-table__wrapper>table>thead>tr th,
.v-data-table.table .v-table__wrapper>table tbody>tr th {
    background-color: #16324A !important;
    color: white;
}

.v-data-table .v-table__wrapper>table>thead>tr>th.v-data-table__th--sortable:hover,
.v-data-table .v-table__wrapper>table tbody>tr>th.v-data-table__th--sortable:hover {
    color: white;
}

.dashboard-student-scroll {
    max-height: 336px;
    overflow-y: auto;
    padding-right: 8px;
}

.dashboard-student-chip-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.dashboard-student-chip {
    width: 100%;
    min-width: auto;
    max-width: none;
    min-height: 40px;
    white-space: normal;
    text-align: left;
}

.dashboard-student-chip-content {
    display: flex;
    flex-direction: column;
    line-height: 1.25;
}

.dashboard-student-chip-content span {
    font-size: 12px;
    opacity: 0.75;
}

.selected-chip {
    background-color: rgba(60, 110, 143, 0.16) !important;
}
</style>

<script src="@/assets/js/nota.js" />
